import { IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import { formatMaterialOptionsList, useFilterMaterials, useMaterialsList } from '../../hooks/core/material';
import SelectField from '../Common/Fields/SelectField';
import { isEmptyArr, makeSlug } from '../../utils';
// import { useState } from 'react';


export default function MaterialForm({ formik, disabled }) {
    const { materialsData, materialsIsLoading } = useMaterialsList(`?is_parent=true`);
    const { filterMaterials, isFilterIsLoading } = useFilterMaterials();
    
    const handleAddNewRow = () => {
        const allMaterials = [...formik.values.materials]
        allMaterials.push({
            field: '',
            field_id: null,
            subOptions: [],
            sub_field: '',
            sub_field_id: null,
            type: 'number',
            value: '',
            unit: '',
            editable: true,
        })
        // setMaterials(allMaterials)
        formik.setFieldValue('materials', allMaterials)
    }
    const handleRemoveRow = (id) => {
        const allMaterials = [...formik.values.materials]
        if (allMaterials.length > 0) { // no minimun row required
            allMaterials.splice(id, 1)
            // setMaterials(allMaterials)
            formik.setFieldValue('materials', allMaterials)
        }
    }
    const handleChangeValue = (text, id) => {
        const allMaterials = [...formik.values.materials]
        allMaterials[id].value = text
        // setMaterials(allMaterials)
        formik.setFieldValue('materials', allMaterials)
    }
    const handleChangeField = async (field_id, field, unit, id) => {
        const allMaterials = [...formik.values.materials]
        allMaterials[id].field = field
        allMaterials[id].field_id = field_id
        allMaterials[id].unit = unit
        const data = await filterMaterials(`?parent=${field_id}`)
        allMaterials[id].subOptions = data?.data
        allMaterials[id].sub_field = data.success ? '' : field
        formik.setFieldValue('materials', allMaterials)
    }
    const handleChangeSubField = async (field_id, field, unit, id) => {
        const allMaterials = [...formik.values.materials]
        allMaterials[id].sub_field = field
        allMaterials[id].sub_field_id = field_id
        allMaterials[id].unit = unit
        // setMaterials(allMaterials)
        formik.setFieldValue('materials', allMaterials)

        // console.log(formik.values.materials);

    }
    useEffect(() => {
        // formik.values.fiber_team_leader && handleChangeField(formik.values.fiber_team_leader)
    }, [])
    return (
                <div className="row border mt-2">
                    {/* <div className='col-12 mt-2'>
                        <h3 className='text-center text-primary' style={{ 'fontSize': '2vh' }}>MATERIALS</h3>
                    </div> */}
                    {formik.values.materials.map((val, i) =>
                        <div className='row mt-2' key={i}>
                            <div className='col-md-4 col-12'>
                                <Typography variant='caption'>Material {i+1} <span className='req'>*</span> <small className='text-primary' role='button' onClick={() => handleRemoveRow(i)}> Remove</small></Typography>
                               
                                <SelectField
                                    // name={`${val.field}-${i}`}
                                    name={makeSlug(`${val.field}-${i}`)}
                                    options={materialsData?.data.map(formatMaterialOptionsList)}
                                    value={materialsData?.data.map(formatMaterialOptionsList).filter(function (option) {
                                        return option.value === val.field_id;
                                    })}
                                    onChange={(e) => handleChangeField(e.value, e.name, e.unit, i)}
                                    isLoading={materialsIsLoading}
                                    isDisabled={disabled}
                                />
                            </div>
                            {!isEmptyArr(formik.values.materials[i].subOptions) &&
                                <div className='col-md-4 col-6'>
                                    <Typography variant='caption'>Child Material <span className='req'>*</span></Typography>
                                    {/* {console.log(formik.values.materials[i].subOptions)} */}
                                    <SelectField
                                        // name={`${val.field}-${i}`}
                                        name={makeSlug(`${val.field}-${i}`)}
                                        options={formik.values.materials[i].subOptions?.map(formatMaterialOptionsList)}
                                        value={formik.values.materials[i].subOptions?.map(formatMaterialOptionsList).filter(function (option) {
                                            return option.value === val.sub_field_id;
                                        })}
                                        onChange={(e) => handleChangeSubField(e.value, e.name, e.unit, i)}
                                        isLoading={isFilterIsLoading}
                                        isDisabled={disabled}
                                    />
                                </div>}
                            {val.sub_field &&
                                <div className='col-md-4 col-6 mt-2'>
                                    <TextField
                                        type={val.type}
                                        label={`${val.sub_field} ${val.unit ? `(${val.unit})` : ''}` || 'Value'}
                                        name={makeSlug(`${val.field}-${i}`)}
                                        value={val.value}
                                        onChange={(e) => handleChangeValue(e.target.value, i) }
                                        variant='standard'
                                        error={val.value === ''}
                                        helperText={`${val.sub_field} is required`}
                                        size="small"
                                        margin="dense"
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="start">
                                                    <IconButton onClick={() => handleRemoveRow(i)}>
                                                        <RemoveCircleOutlineOutlinedIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>}
                               
                        </div>
                    )}
                    <div className='d-flex justify-content-center d-flex align-items-center mb-2'>
                        <button type='button' className='btn btn-success btn-sm mt-2 btn-style-light' onClick={handleAddNewRow}>
                            <i className="material-icons-sharp">
                                add
                            </i>
                            add material</button>
                    </div>
                </div>

              

    )
}
